module.exports = __webpack_public_path__ + "img/chipin-badge.318d6cf9.svg";